<template>
   <div class="picture-area" v-if="photoData.items.length > 0">
        <strong><a :href="photoData.more_photo_link" target="_blank" @click="titleBp"><em>{{photoData.name}}</em>的图片</a></strong>
        <ul class="ulPic">
            <li v-for="(item,index) in photoData.items" :key="index">
                <a :href="item.link" target="_blank" :title="item.name" @click="contentBp(item)">
                    <img :src="item.photo_src">
                    <p>{{item.name}}({{item.photo_total}}张)</p>
                </a>
                <i></i>
            </li>
        </ul>
        <a :href="photoData.more_photo_link" target="_blank" class="moreLink" @click="moreP">更多图片 &gt;&gt;</a>
	</div>
</template>

<script>
    export default {
        name: 'PictureArea',
        props: {
            photoData: {
                type: Object,
                default: () => ({})
            }
        },
        methods: {
            titleBp() { //标题埋点
                if(this.$global.qType === 1) {
                    this.countAd(4229)
                }else if(this.$global.qType === 2) {
                    this.countAd(4218)
                }else if(this.$global.qType === 3) {
                    this.countAd(4181)
                }
            },
            contentBp(item) {
                if(this.$global.qType === 1) {
                    this.countAd(4230)
                }else if(this.$global.qType === 2) {
                    this.countAd(4219)
                }else if(this.$global.qType === 3) {
                    if(item.name === '外观') {
                        this.countAd(4182)
                    }else if(item.name === '内饰') {
                        this.countAd(4183)
                    }else if(item.name === '空间') {
                        this.countAd(4184)
                    }else if(item.name === '其他') {
                        this.countAd(4185)
                    }
                }
            },
            moreP() {
                 if(this.$global.qType === 1) {
                    this.countAd(4231)
                }else if(this.$global.qType === 2) {
                    this.countAd(4220)
                }else if(this.$global.qType === 3) {
                    this.countAd(4186)
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
.picture-area {
    font-size: 12px;
    height: 150px;
    margin-bottom: 25px;
    position: relative;
    z-index: 1;
    strong {
        font-weight: normal;
        font-size: 16px;
        line-height: 32px;
        a {
            text-decoration: underline;
            color: #225599;
        }
        em {
            color: #cc0000;
            text-decoration: underline;
            font-style: normal;
        }
    }
    .ulPic {
        margin-left: -47px;
        width: 668px;
        display: flex;
        justify-content: flex-start;
        li {
            margin-left: 47px;
            width: 120px;
            height: 90px;
            overflow: hidden;
            display: inline;
            p {
                text-align: center;
                height: 20px;
                line-height: 20px;
                margin-top: -20px;
                position: relative;
                z-index: 99;
                background-color: rgba(0, 0, 0, .5);
            }
            img {
                width: 120px;
                height: 90px;
            }
            a {
                color: #fff;
            }
        }
    }
    .moreLink {
        margin-top: 14px;
        line-height: 14px;
        display: inline-block;
        height: 14px;
        text-decoration: underline;
        color: #225599;
    }
}
</style>